"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Log = exports.Permissao = exports.schema = void 0;
const permissoes_1 = require("../utils/permissoes");
const permissoes_2 = require("./permissoes");
exports.schema = {
    Usuário: {
        Login: {
            chaves: { group: permissoes_2.GrupoPermissoes.Arquivo, role: permissoes_2.FuncaoArquivo.NovoLogin },
            chavesLog: { group: 1, role: 12 },
            acao: 'Entrou no sistema',
            descricao: 'Entrar no sistema',
            setor: "1" /* Configurações */,
        },
        'Sair da Aplicação': {
            chaves: { group: permissoes_2.GrupoPermissoes.Arquivo, role: permissoes_2.FuncaoArquivo.SairAplicacao },
            chavesLog: { group: 1, role: 13 },
            acao: 'Saiu da aplicação',
            descricao: 'Sair da aplicação',
            setor: "1" /* Configurações */,
        },
        'Cadastro de Usuários': {
            chaves: { group: permissoes_2.GrupoPermissoes.Arquivo, role: permissoes_2.FuncaoArquivo.CadastroUsuarios },
            acao: 'Alterou dados de usuário',
            descricao: 'Alterar dados de usuários',
            setor: "1" /* Configurações */,
        },
        'Alterar Senha de Usuário': {
            chaves: { group: permissoes_2.GrupoPermissoes.Utilitarios, role: permissoes_2.FuncaoUtilitarios.AlterarSenhaUsuario },
            chavesLog: { group: 1, role: 14 },
            acao: 'Alterou a senha de usuário',
            descricao: 'Alterar a senha de usuário',
            setor: "1" /* Configurações */,
        },
        'Monitor de Usuários': {
            chaves: { group: permissoes_2.GrupoPermissoes.Utilitarios, role: permissoes_2.FuncaoUtilitarios.MonitorUsuarios },
            chavesLog: { group: 1, role: 16 },
            acao: 'Acessou Monitor de Usuários',
            descricao: 'Acessar Monitor de Usuários',
            setor: "1" /* Configurações */,
        },
        'Log de Usuários': {
            chaves: { group: permissoes_2.GrupoPermissoes.Utilitarios, role: permissoes_2.FuncaoUtilitarios.LogUsuarios },
            acao: 'Acessou Log de Usuários',
            descricao: 'Acessar Log de Usuários',
            setor: "1" /* Configurações */,
        },
        Habilitado: {
            chaves: { group: permissoes_2.GrupoPermissoes.OpcoesUsuario, role: permissoes_2.FuncaoOpcoesUsuario.Habilitado },
            acao: 'Habilitou o usuário para uso geral do sistema',
            descricao: 'Habilita o usuário para uso geral do sistema',
            setor: "1" /* Configurações */,
        },
        'Usuário MASTER': {
            chaves: { group: permissoes_2.GrupoPermissoes.OpcoesUsuario, role: permissoes_2.FuncaoOpcoesUsuario.UsuarioMASTER },
            acao: 'Marcou usuário como MASTER',
            descricao: 'Usuário MASTER, sobrepõe todas as outras permissões.',
            setor: "1" /* Configurações */,
        },
        'Supervisor do Sistema': {
            chaves: { group: permissoes_2.GrupoPermissoes.OpcoesUsuario, role: permissoes_2.FuncaoOpcoesUsuario.SupervisorSistema },
            acao: 'Marcou como supervisor do sistema',
            descricao: 'Surpervisor dos Sistema para dados restritos.',
            setor: "1" /* Configurações */,
        },
        'Professor Online Consulta': {
            chaves: { group: permissoes_2.GrupoPermissoes.OpcoesUsuario, role: permissoes_2.FuncaoOpcoesUsuario.ProfessorOnlineConsultar },
            acao: 'Permitiu consultar dados no método professor online.',
            descricao: 'Consultar dados no módulo Professor Online.',
            setor: "1" /* Configurações */,
        },
        'Professor Online Alterar': {
            chaves: { group: permissoes_2.GrupoPermissoes.OpcoesUsuario, role: permissoes_2.FuncaoOpcoesUsuario.ProfessorOnlineAlterar },
            acao: 'Permitiu alterar dados no módulo professor online.',
            descricao: 'Alterar dados no módulo Professor Online.',
            setor: "2" /* Acadêmico */,
        },
        'Professor Online Alterar Avisos': {
            chaves: { group: permissoes_2.GrupoPermissoes.OpcoesUsuario, role: permissoes_2.FuncaoOpcoesUsuario.ProfessorOnlineAvisosAlterar },
            acao: 'Permitiu alterar avisos no módulo professor online.',
            descricao: 'Alterar Avisos no módulo Professor Online.',
            setor: "2" /* Acadêmico */,
        },
        'Professor Online Alterar Ocorrências': {
            chaves: { group: permissoes_2.GrupoPermissoes.OpcoesUsuario, role: permissoes_2.FuncaoOpcoesUsuario.ProfessorOnlineOcorrenciasAlterar },
            acao: 'Permitiu alterar ocorrências no móduloprofessor online.',
            descricao: 'Alterar as Ocorrências no módulo Professor Online.',
            setor: "2" /* Acadêmico */,
        },
        'Professor Online Configurações': {
            chaves: { group: permissoes_2.GrupoPermissoes.OpcoesUsuario, role: permissoes_2.FuncaoOpcoesUsuario.ProfessorOnlineConfiguracoes },
            acao: 'Permitiu alterar as configuraçães do módulo professor online.',
            descricao: 'Alterar as Configurações do módulo Professor Online.',
            setor: "1" /* Configurações */,
        },
        'Dados Pessoais': {
            chaves: { group: permissoes_2.GrupoPermissoes.OpcoesUsuario, role: permissoes_2.FuncaoOpcoesUsuario.DadosPessoais },
            acao: 'Acessou a página de dados pessoais.',
            descricao: 'Acesso a dados privativos das pessoas.',
            setor: "1" /* Configurações */,
        },
        'Dados Sensiveis': {
            chaves: { group: permissoes_2.GrupoPermissoes.OpcoesUsuario, role: permissoes_2.FuncaoOpcoesUsuario.DadosSensiveis },
            acao: 'Acessou dados sensíveis.',
            descricao: 'Acesso a dados sensíveis das pessoas.',
            setor: "4" /* Administrativo */,
        },
    },
    Cursos: Object.assign(Object.assign({ Menu: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.Cursos },
            acao: 'Acessou o menu de cursos.',
            descricao: 'Acessar o menu de cursos.',
            setor: "2" /* Acadêmico */,
        } }, (0, permissoes_1.funcoesPadrao)(permissoes_2.GrupoPermissoes.Cursos, 'de curso', "2" /* Acadêmico */, permissoes_2.GrupoPermissoes.Cursos)), { 'Reajustar Mensalidades': {
            chaves: { group: permissoes_2.GrupoPermissoes.Cursos, role: permissoes_2.FuncaoCursos.ReajustarMensalidades },
            //TODO: valor o que mais?
            acao: 'Reajustou mensalidades de um curso.',
            descricao: 'Reajustar Mensalidades',
            setor: "3" /* Financeiro */,
            inativo: true,
        } }),
    'Séries e Turmas': Object.assign(Object.assign({ Menu: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.Series },
            acao: 'Acessou o menu de séries',
            descricao: 'Acessar o menu de séries',
            setor: "2" /* Acadêmico */,
        }, 'Incluir Série': Object.assign({}, (0, permissoes_1.funcoesPadrao)(permissoes_2.GrupoPermissoes.Series, 'de séries', "2" /* Acadêmico */, permissoes_2.GrupoPermissoes.Series).Incluir), 'Alterar Série': Object.assign({}, (0, permissoes_1.funcoesPadrao)(permissoes_2.GrupoPermissoes.Series, 'de séries', "2" /* Acadêmico */, permissoes_2.GrupoPermissoes.Series).Alterar), 'Excluir Série': Object.assign({}, (0, permissoes_1.funcoesPadrao)(permissoes_2.GrupoPermissoes.Series, 'de séries', "2" /* Acadêmico */, permissoes_2.GrupoPermissoes.Series).Excluir) }, (0, permissoes_1.funcoesPadrao)(permissoes_2.GrupoPermissoes.Turmas, 'de turmas', "2" /* Acadêmico */)), { Movimento: {
            chaves: { group: permissoes_2.GrupoPermissoes.Series, role: permissoes_2.FuncaoSeries.Movimento },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Series, role: permissoes_2.FuncaoSeries.Movimento },
            acao: 'Acessou o movimento de turmas',
            descricao: 'Gerar movimento de turmas',
            setor: "2" /* Acadêmico */,
        }, Relatórios: {
            chaves: { group: permissoes_2.GrupoPermissoes.Series, role: permissoes_2.FuncaoSeries.Relatorios },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Series, role: permissoes_2.FuncaoSeries.Relatorios },
            acao: 'Acessou os relatórios de turmas',
            descricao: 'Gerar relatários de turmas',
            setor: "2" /* Acadêmico */,
        }, Notas: {
            chaves: { group: permissoes_2.GrupoPermissoes.Series, role: permissoes_2.FuncaoSeries.Notas },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Series, role: permissoes_2.FuncaoSeries.Notas },
            acao: 'Acessou as notas de turmas',
            descricao: 'Alterar as notas de turmas',
            setor: "2" /* Acadêmico */,
        }, 'Aulas Dadas': {
            chaves: { group: permissoes_2.GrupoPermissoes.Series, role: permissoes_2.FuncaoSeries.AulasDadas },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Series, role: permissoes_2.FuncaoSeries.AulasDadas },
            acao: 'Acessou as aulas dadas de turmas',
            descricao: 'Alterar as aulas dadas',
            setor: "2" /* Acadêmico */,
        }, 'Incluir Matéria na Grade': {
            chaves: { group: permissoes_2.GrupoPermissoes.Series, role: permissoes_2.FuncaoSeries.IncluirMateriasGrade },
            acao: 'Incluíu matéria na grade',
            descricao: 'Incluir Matéria na Grade',
            setor: "2" /* Acadêmico */,
        }, 'Alterar Matéria na Grade': {
            chaves: { group: permissoes_2.GrupoPermissoes.Series, role: permissoes_2.FuncaoSeries.AlteraMateriaGrade },
            acao: 'Alterou matéria da grade',
            descricao: 'Alterar Matéria na Grade',
            setor: "2" /* Acadêmico */,
        }, 'Excluir Matéria da Grade': {
            chaves: { group: permissoes_2.GrupoPermissoes.Series, role: permissoes_2.FuncaoSeries.ExcluirMateriaGrade },
            acao: 'Excluiu matéria da grade',
            descricao: 'Excluir Matéria da Grade',
            setor: "2" /* Acadêmico */,
        }, 
        //FIXME: Group da permissão está certo???
        'Indicar Professor': {
            chaves: { group: permissoes_2.GrupoPermissoes.Series, role: permissoes_2.FuncaoSeries.IndicarProfessor },
            chavesLog: { group: 5, role: 5 },
            acao: 'Indicou um professor',
            descricao: 'Indicar Professor a uma turma',
            setor: "2" /* Acadêmico */,
        }, 'Excluir Professor da Turma': {
            chavesLog: { group: 5, role: 6 },
            acao: 'Excluíu professor da turma',
            descricao: 'Excluir professor da turma',
            setor: "2" /* Acadêmico */,
        }, 
        //TODO: Excluir Professor
        'Alterar Número de Chamada': {
            chaves: { group: permissoes_2.GrupoPermissoes.Series, role: permissoes_2.FuncaoSeries.AlterarNChamada },
            acao: 'Alterou o número de chamada',
            descricao: 'Alterar Número de Chamada',
            setor: "2" /* Acadêmico */,
        }, 'Alterar Dados Cadastrais': {
            chaves: { group: permissoes_2.GrupoPermissoes.Series, role: permissoes_2.FuncaoSeries.AlterarDadosCadastrais },
            acao: 'Entrou nos dados cadastrais',
            descricao: 'Alterar Dados Cadastrais',
            setor: "2" /* Acadêmico */,
        }, 'Cancelar Matricula': {
            chaves: { group: permissoes_2.GrupoPermissoes.Series, role: permissoes_2.FuncaoSeries.CancelarMatricula },
            acao: 'Cancelou matricula',
            descricao: 'Cancelar Matricula',
            setor: "2" /* Acadêmico */,
        }, 'Lista Alunos': {
            chaves: { group: permissoes_2.GrupoPermissoes.Series, role: permissoes_2.FuncaoSeries.ImprimirListaAlunos },
            acao: 'Entrou na lista de alunos',
            descricao: 'Ver lista de alunos',
            setor: "2" /* Acadêmico */,
        }, 'Diário Classe': {
            chaves: { group: permissoes_2.GrupoPermissoes.Series, role: permissoes_2.FuncaoSeries.ImprimirDiarioClasse },
            acao: 'Entrou no diário classe',
            descricao: 'Ver diário classe',
            setor: "2" /* Acadêmico */,
        }, 'Digitação de Notas': {
            chaves: { group: permissoes_2.GrupoPermissoes.Series, role: permissoes_2.FuncaoSeries.DigitacaoNotas },
            acao: 'Digitou nota',
            descricao: 'Digitação de Notas',
            setor: "2" /* Acadêmico */,
        }, 'Excluir Nome Lista': {
            chaves: { group: permissoes_2.GrupoPermissoes.Series, role: permissoes_2.FuncaoSeries.ExcluirNomeLista },
            acao: 'Excluiu nome da lista',
            descricao: 'Excluir Nome Lista',
            setor: "2" /* Acadêmico */,
        }, 'Gerar Chamada': {
            chaves: { group: permissoes_2.GrupoPermissoes.Series, role: permissoes_2.FuncaoSeries.GerarChamada },
            acao: 'Gerou chamada',
            descricao: 'Gerar Chamada',
            setor: "2" /* Acadêmico */,
        }, 'Fixar Chamada': {
            chaves: { group: permissoes_2.GrupoPermissoes.Series, role: permissoes_2.FuncaoSeries.FixarChamada },
            acao: 'Fixou chamada',
            descricao: 'Fixar Chamada',
            setor: "2" /* Acadêmico */,
        }, 'Alterar Data de Saida': {
            chaves: { group: permissoes_2.GrupoPermissoes.Series, role: permissoes_2.FuncaoSeries.AlterarDataSaida },
            acao: 'Alterou data de saída',
            descricao: 'Alterar Data de Saida',
            setor: "2" /* Acadêmico */,
        }, 'Remanejar Aluno': {
            chaves: { group: permissoes_2.GrupoPermissoes.Series, role: permissoes_2.FuncaoSeries.RemanejarAluno },
            chavesLog: { group: 7, role: 24 },
            acao: 'Remanejou aluno',
            descricao: 'Remanejar Aluno',
            setor: "2" /* Acadêmico */,
        } }),
    Matérias: Object.assign(Object.assign({ Menu: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.Materias },
            acao: 'Acessou o menu de matérias',
            descricao: 'Acessar o menu de matérias',
            setor: "2" /* Acadêmico */,
        } }, (0, permissoes_1.funcoesPadrao)(permissoes_2.GrupoPermissoes.Materias, 'de materia', "2" /* Acadêmico */, permissoes_2.GrupoPermissoes.Materias)), { 'Sequência Historico Escolar': {
            chaves: { group: permissoes_2.GrupoPermissoes.Materias, role: permissoes_2.FuncaoMaterias.SeqHistoricoEscolar },
            acao: 'Alterou a sequência',
            descricao: 'Alterar a sequência das matérias',
            setor: "2" /* Acadêmico */,
        } }),
    'Grade de Materias': Object.assign({}, (0, permissoes_1.funcoesPadrao)(permissoes_2.GrupoPermissoes.GradeMaterias, ' de grade de materia', "2" /* Acadêmico */, permissoes_2.GrupoPermissoes.GradeMaterias)),
    'Grade de Professores': Object.assign({}, (0, permissoes_1.funcoesPadrao)(permissoes_2.GrupoPermissoes.GradeProfessores, 'de grade de professor', "2" /* Acadêmico */)),
    Ocorrência: {
        'Categoria de Ocorrência': {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.CategoriasOcorrencia },
            acao: 'Cadastrou uma categoria',
            descricao: 'Cadastrar Categoria de Ocorréncia',
            setor: "2" /* Acadêmico */,
        },
        'Tipo de Ocorrência': {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.TiposOcorrencia },
            acao: 'Cadastrou um tipo de ocorrência',
            descricao: 'Cadastrar Tipo de Ocorrência',
            setor: "2" /* Acadêmico */,
        },
        'Consultar Ocorrências': {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.ConsultarOcorrencias },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.ConsultarOcorrencias },
            acao: 'Consultou ocorrências',
            descricao: 'Consultar Ocorrências',
            setor: "2" /* Acadêmico */,
        },
        'Cadastrar Ocorrência': {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.CadastrarOcorrencias },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.CadastrarOcorrencias },
            acao: 'Cadastrou uma ocorrência',
            descricao: 'Cadastrar Ocorrência',
            setor: "2" /* Acadêmico */,
        },
        'Visualizar Ocorrência Oculta': {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.VisualizarOcorrenciasOcultas },
            acao: 'Visualizou uma ocorrência oculta',
            descricao: 'Visualizar Ocorrência Oculta',
            setor: "2" /* Acadêmico */,
        },
        'Relatório de Ocorrências': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.RelatorioOcorrencias },
            acao: 'Gerou relatório de ocorrências',
            descricao: 'Gerar Relatório de Ocorrências',
            setor: "2" /* Acadêmico */,
        },
    },
    Alunos: Object.assign(Object.assign({ Menu: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.Alunos },
            acao: 'Acessou o menu de alunos',
            descricao: 'Acessar o menu de alunos',
            setor: "2" /* Acadêmico */,
        } }, (0, permissoes_1.funcoesPadrao)(permissoes_2.GrupoPermissoes.Alunos, 'do aluno', "2" /* Acadêmico */, permissoes_2.GrupoPermissoes.Alunos)), { 'Inclusão de Alunos Novos': {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.InclusaoAlunosNovos },
            acao: 'Incluiu aluno',
            descricao: 'Incluir Aluno',
            setor: "2" /* Acadêmico */,
        }, Mensalidades: {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.Mensalidades },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.Mensalidades },
            acao: 'Acessou as mensalidades',
            descricao: 'Acessar as mensalidades pelo aluno',
            setor: "3" /* Financeiro */,
        }, Matrícula: {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.Matricula },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.Matricula },
            acao: 'Matriculou aluno',
            descricao: 'Matricular Aluno',
            setor: "2" /* Acadêmico */,
        }, 'Mudar Situacao do Aluno': {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.MudarSituacaoAluno },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Alunos, role: 25 },
            acao: 'Mudou a situação do aluno',
            descricao: 'Mudar situação do aluno',
            setor: "2" /* Acadêmico */,
        }, Boletim: {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.Boletim },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.Boletim },
            acao: 'Acessou o boletim',
            descricao: 'Acessar o boletim pelo aluno',
            setor: "2" /* Acadêmico */,
        }, Desistência: {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.Desistencia },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.Desistencia },
            acao: 'Alterou a desistência do aluno',
            descricao: 'Alterar Desisténcia do Aluno',
            setor: "2" /* Acadêmico */,
        }, Transferência: {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.Transferencia },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Alunos, role: 26 },
            acao: 'Alterou a transferência do aluno',
            descricao: 'Alterar Transferência do Aluno',
            setor: "2" /* Acadêmico */,
        }, 'Cancelamento da Matrícula': {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.CancelamentoMatricula },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.CancelamentoMatricula },
            acao: 'Cancelou a matrícula do aluno',
            descricao: 'Cancelar Matrícula do Aluno',
            setor: "2" /* Acadêmico */,
        }, 'Requerimento de Matrícula': {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.RequerimentoMatricula },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.RequerimentoMatricula },
            acao: 'Gerou requerimento de matrícula do aluno',
            descricao: 'Gerar Requerimento de Matrícula do Aluno',
            setor: "2" /* Acadêmico */,
        }, 'Declaração de Matrícula': {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.DeclaracaoMatricula },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.DeclaracaoMatricula },
            acao: 'Gerou declaração de matrícula do aluno',
            descricao: 'Gerar Declaração de Matrícula do Aluno',
            setor: "2" /* Acadêmico */,
        }, 'Requerimento de Transferência': {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.RequerimentoTransferencia },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.RequerimentoTransferencia },
            acao: 'Gerou requerimento de transferência do aluno',
            descricao: 'Gerar Requerimento de Transferência do Aluno',
            setor: "2" /* Acadêmico */,
        }, 'Ficha Individual': {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.FichaIndividual },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.FichaIndividual },
            acao: 'Gerou ficha individual do aluno',
            descricao: 'Gerar Ficha Individual do Aluno',
            setor: "2" /* Acadêmico */,
        }, 'Histórico Escolar': {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.HistoricoEscolar },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.HistoricoEscolar },
            acao: 'Gerou histérico escolar do aluno',
            descricao: 'Gerar Histérico Escolar do Aluno',
            setor: "2" /* Acadêmico */,
        }, 'Declaração de Frequência': {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.DeclaracaoFrequencia },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.DeclaracaoFrequencia },
            acao: 'Gerou declaração de frequência do aluno',
            descricao: 'Gerar Declaração de Frequência do Aluno',
            setor: "2" /* Acadêmico */,
        }, 'Declaração Transferência': {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.DeclaracaoTransferencia },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.DeclaracaoTransferencia },
            acao: 'Gerou declaração de transferência do aluno',
            descricao: 'Gerar Declaração de Transferência do aluno',
            setor: "2" /* Acadêmico */,
        }, Frequência: {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.Frequencia },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.Frequencia },
            acao: 'Alterou a frequência do aluno',
            descricao: 'Alterar a frequência do aluno',
            setor: "2" /* Acadêmico */,
        }, Falecimento: {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.Falecimento },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.Falecimento },
            acao: 'Alterou o falecimento do aluno',
            descricao: 'Alterar o falecimento do aluno',
            setor: "2" /* Acadêmico */,
        }, Turma: {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.Turma },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.Turma },
            acao: 'Acessou a turma do aluno',
            descricao: 'Acessar a turma do aluno',
            setor: "2" /* Acadêmico */,
        }, 'Informar Desconto na Matrícula': {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.InformarDescontoMatricula },
            acao: 'Informou desconto na matrícula',
            descricao: 'Informar Desconto na Matrícula',
            setor: "3" /* Financeiro */,
        }, 'Informar Data Primeiro Vencimento': {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.InformarData1Vencimento },
            acao: 'Informou data primeiro vencimento',
            descricao: 'Informar a data do primeiro vencimento',
            setor: "3" /* Financeiro */,
        }, Cheque: {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.Cheques },
            acao: 'Acessou  os cheques do aluno',
            descricao: 'Acessar os cheques do aluno',
            setor: "3" /* Financeiro */,
        }, 'Adaptação e Dependência': {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.AdaptacaoDependencia },
            acao: 'Alterou a adaptação e dependência do aluno',
            descricao: 'Alterar a adaptação e dependência do aluno',
            setor: "3" /* Financeiro */,
        }, Empréstimo: {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.Emprestimos },
            acao: 'Acessou os empréstimos do aluno',
            descricao: 'Acessar os empréstimos do aluno',
            setor: "3" /* Financeiro */,
        }, Gratuídade: {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.Gratuidades },
            acao: 'Acessou as gratuidades do aluno',
            descricao: 'Acessar as gratuidades do aluno',
            setor: "3" /* Financeiro */,
        }, 'Situação Financeira': {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.SituacaoFinanceira },
            acao: 'Acessou a situação financeira do aluno',
            descricao: 'Acessar a situação financeira do aluno',
            setor: "3" /* Financeiro */,
        }, 'Ficha Familiar': {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.FichaFamiliar },
            acao: 'Acessou a ficha familiar do aluno',
            descricao: 'Acessar a ficha familiar do aluno',
            setor: "2" /* Acadêmico */,
        }, 'Alterar Data de Matricula': {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.AlterarDataMatricula },
            acao: 'Alterou a data de matrícula do aluno',
            descricao: 'Alterar a data de matrícula do aluno',
            setor: "2" /* Acadêmico */,
        }, 'Atestado Médico': {
            chaves: { group: permissoes_2.GrupoPermissoes.Alunos, role: permissoes_2.FuncaoAlunos.AtestadosMedicos },
            acao: 'Alterou o atestado médico do aluno',
            descricao: 'Alterar o atestado médico do aluno',
            setor: "2" /* Acadêmico */,
        } }),
    Fornecedor: Object.assign({ Menu: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.Fornecedores },
            acao: 'Acessou o cadastro de fornecedor',
            descricao: 'Acessar os dados de fornecedores',
            setor: "3" /* Financeiro */,
        } }, (0, permissoes_1.funcoesPadrao)(permissoes_2.GrupoPermissoes.Fornecedores, 'de fornecedor', "3" /* Financeiro */, permissoes_2.GrupoPermissoes.Fornecedores)),
    'Funcionário e Professor': Object.assign({ Menu: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.ProfessoresFuncionarios },
            acao: 'Acessou o cadastro de funcionário',
            descricao: 'Acessar os dados dos funcionários e professores',
            setor: "4" /* Administrativo */,
        } }, (0, permissoes_1.funcoesPadrao)(permissoes_2.GrupoPermissoes.FuncProfessores, 'de funcionário', "4" /* Administrativo */, 6)),
    'Plano de Contas': Object.assign(Object.assign({ Menu: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.PlanoContas },
            acao: 'Acessou os dados de plano de contas',
            descricao: 'Acessar os dados de plano de contas',
            setor: "4" /* Administrativo */,
        } }, (0, permissoes_1.funcoesPadrao)(permissoes_2.GrupoPermissoes.PlanoContas, 'de plano de contas', "4" /* Administrativo */, 10)), { 'Ficha Razão': {
            chaves: { group: permissoes_2.GrupoPermissoes.PlanoContas, role: permissoes_2.FuncaoPlanoContas.FichaRazao },
            acao: 'Acessou a ficha razão',
            descricao: 'Acessar a ficha razão',
            setor: "3" /* Financeiro */,
        } }),
    'Histórico Padrão Contábil': Object.assign({ Menu: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.HistoricoPadrao },
            acao: 'Acessou os dados de histórico padrão contábil',
            descricao: 'Acessar os dados de histórico padrão contábil',
            setor: "3" /* Financeiro */,
        } }, (0, permissoes_1.funcoesPadrao)(permissoes_2.GrupoPermissoes.HistoricoPadrao, 'de histórico padrão', "3" /* Financeiro */, permissoes_2.GrupoPermissoes.HistoricoPadrao)),
    'Conta Bancária': Object.assign(Object.assign({ Menu: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.ContasBancarias },
            acao: 'Acessou os dados de conta bancária',
            descricao: 'Acessar os dados de conta bancária',
            setor: "3" /* Financeiro */,
        } }, (0, permissoes_1.funcoesPadrao)(permissoes_2.GrupoPermissoes.ContasBancarias, 'de conta bancária', "3" /* Financeiro */, permissoes_2.GrupoPermissoes.ContasBancarias)), { Movimento: {
            chaves: { group: permissoes_2.GrupoPermissoes.ContasBancarias, role: permissoes_2.FuncaoContasBancarias.Movimento },
            acao: 'Acessou os movimentos de conta bancária',
            descricao: 'Acessar os movimentos de conta bancária',
            setor: "3" /* Financeiro */,
        } }),
    Mensalidade: {
        Incluir: Object.assign({}, (0, permissoes_1.funcoesPadrao)(permissoes_2.GrupoPermissoes.Mensalidades, 'de mensalidade', "3" /* Financeiro */, permissoes_2.GrupoPermissoes.Mensalidades)
            .Incluir),
        Alterar: Object.assign({}, (0, permissoes_1.funcoesPadrao)(permissoes_2.GrupoPermissoes.Mensalidades, 'de mensalidade', "3" /* Financeiro */, permissoes_2.GrupoPermissoes.Mensalidades)
            .Alterar),
        Receber: {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.Receber },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.Receber },
            acao: 'Recebeu a mensalidade',
            descricao: 'Receber mensalidades',
            setor: "3" /* Financeiro */,
        },
        'Autenticar Recebimento': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.AutenticarRecebimentos },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: 17 },
            acao: 'Autenticou o recebimento da mensalidade',
            descricao: 'Autenticar recebimento da mensalidade',
            setor: "3" /* Financeiro */,
        },
        'Receber pelo Caixa da Tesouraria': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.ReceberCaixaTesouraria },
            acao: 'Recebeu a mensalidade pelo caixa da tesouraria',
            descricao: 'Receber mensalidades pelo caixa da tesouraria',
            setor: "3" /* Financeiro */,
        },
        'Receber por Conta Bancária': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.ReceberContasBancarias },
            acao: 'Recebeu a mensalidade pela conta bancária',
            descricao: 'Receber mensalidades pela conta bancária',
            setor: "3" /* Financeiro */,
        },
        Estornar: {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.Estornar },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.Estornar },
            acao: 'Estornou a mensalidade',
            descricao: 'Estornar mensalidades',
            setor: "3" /* Financeiro */,
        },
        Devolver: {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.Devolver },
            acao: 'Devolveu a mensalidade',
            descricao: 'Devolver mensalidades',
            setor: "3" /* Financeiro */,
        },
        Excluir: {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.Excluir },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.Excluir },
            acao: 'Excluiu a mensalidade',
            descricao: 'Excluir mensalidades',
            setor: "3" /* Financeiro */,
        },
        'Alterar Vencimento de Mensalidades': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.AlterarVencimentoMensalidades },
            acao: 'Alterou o vencimento de mensalidades',
            descricao: 'Alterar vencimento de mensalidades',
            setor: "3" /* Financeiro */,
        },
        'Alterar Tipo de Desconto Recebido': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.AlterarTipoDescRecebido },
            acao: 'Alterou o tipo de desconto recebido',
            descricao: 'Alterar tipo de desconto recebido',
            setor: "3" /* Financeiro */,
        },
        'Alterar Data de Recebimento na Baixa': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.AlterarDataRecebimentoBaixa },
            acao: 'Alterou a data de recebimento na baixa',
            descricao: 'Alterar data de recebimento na baixa',
            setor: "3" /* Financeiro */,
        },
        'Conceder desconto na Baixa': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.ConcederDescontoBaixa },
            acao: 'Concedeu desconto na baixa',
            descricao: 'Conceder desconto na baixa',
            setor: "3" /* Financeiro */,
        },
        'Ajustar Mensalidades de Filantropia': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.AjustarMensalidadesFilantropia },
            acao: 'Ajustou mensalidades de filantropia',
            descricao: 'Ajustar mensalidades de filantropia',
            setor: "3" /* Financeiro */,
        },
        'Alterar Valor de Mensalidades': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.AlterarValorMensalidades },
            acao: 'Alterou o valor de mensalidades',
            descricao: 'Alterar valor de mensalidades',
            setor: "3" /* Financeiro */,
        },
        'Alterar opção de Perder Desconto Após Vencimento': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.AlterarPerdeDescAposVenc },
            acao: 'Alterou a opção de perder desconto após vencimento',
            descricao: 'Alterar opção de perder desconto após vencimento',
            setor: "3" /* Financeiro */,
        },
        'Alterar Data de Crédito na Baixa Manual': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.AlterarDataCreditoBaixaManual },
            acao: 'Alterou a data de crédito na baixa manual',
            descricao: 'Alterar data de crédito na baixa manual',
            setor: "3" /* Financeiro */,
        },
        'Liberar Juros na Baixa': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.LiberarJurosBaixa },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: 18 },
            acao: 'Liberou juros na baixa',
            descricao: 'Liberar juros na baixa',
            setor: "3" /* Financeiro */,
        },
        'Informar Valor Recebido na Baixa': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.InformarValorRecebidoBaixa },
            acao: 'Informou o valor recebido na baixa',
            descricao: 'Informar valor recebido na baixa',
            setor: "3" /* Financeiro */,
        },
        'Emitir Recibo': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.Recibos },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.Recibos },
            acao: 'Emitiu recibo',
            descricao: 'Emitir recibo',
            setor: "3" /* Financeiro */,
        },
        'Reltório de Mensalidades em Atraso': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.RelMensalidadesAtraso },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.RelMensalidadesAtraso },
            acao: 'Acessou o relatório de mensalidades em atraso',
            descricao: 'Acessar relatório de mensalidades em atraso',
            setor: "3" /* Financeiro */,
        },
        'Recibo de Imposto de Renda': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.ReciboImpostoRenda },
            acao: 'Emitiu recibo de imposto de renda',
            descricao: 'Emitir recibo de imposto de renda',
            setor: "3" /* Financeiro */,
        },
        'Reltório de Pendências de Desistentes': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.RelPendenciasDesistentes },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.RelPendenciasDesistentes },
            acao: 'Acessou o relatório de pendências de desistentes',
            descricao: 'Acessar relatório de pendências de desistentes',
            setor: "3" /* Financeiro */,
        },
        'Reltório de Pendências de Aprovados': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.RelPendenciasAprovados },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.RelPendenciasAprovados },
            acao: 'Acessou o relatório de pendências de aprovados',
            descricao: 'Acessar relatório de pendências de aprovados',
            setor: "3" /* Financeiro */,
        },
        'Reltório de Previsão de Recebimento': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.RelPrevisaoRecebimento },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.RelPrevisaoRecebimento },
            acao: 'Acessou o relatório de previsão de recebimentos',
            descricao: 'Acessar relatório de previsão de recebimentos',
            setor: "3" /* Financeiro */,
        },
        'Reltório de Valores Recebidos': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.RelValoresRecebidos },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.RelValoresRecebidos },
            acao: 'Acessou o relatório de valores recebidos',
            descricao: 'Acessar relatório de valores recebidos',
            setor: "3" /* Financeiro */,
        },
        'Reltório de Valores Recebidos por Vencimento': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.RelValoresRecebidosVencimento },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.RelValoresRecebidosVencimento },
            acao: 'Acessou o relatório de valores recebidos por vencimento',
            descricao: 'Acessar relatório de valores recebidos por vencimento',
            setor: "3" /* Financeiro */,
        },
        'Emissão de Cartas de Cobrança': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.EmissaoCartasCobranca },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.EmissaoCartasCobranca },
            acao: 'Emitiu cartas de cobrança',
            descricao: 'Emitir cartas de cobrança',
            setor: "3" /* Financeiro */,
        },
        'Situação Financeira do Aluno': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.SituacaoFinanceiraAluno },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.SituacaoFinanceiraAluno },
            acao: 'Acessou o relatário de situação financeira do aluno',
            descricao: 'Acessar relatário de situação financeira do aluno',
            setor: "3" /* Financeiro */,
        },
        'Resumo da Posição Financeira': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.ResumoPosicaoFinanceira },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.ResumoPosicaoFinanceira },
            acao: 'Acessou o resumo da posição financeira',
            descricao: 'Acessar resumo da posição financeira',
            setor: "3" /* Financeiro */,
        },
        'Mapa de Mensalidades Recebidas': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.MapaMensalidadesRecebidas },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.MapaMensalidadesRecebidas },
            acao: 'Acessou o mapa de mensalidades recebidas',
            descricao: 'Acessar mapa de mensalidades recebidas',
            setor: "3" /* Financeiro */,
        },
        'Mapa de Previsão de Recebimentos': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.MapaPrevisaoRecebimentos },
            acao: 'Acessou o mapa de previsão de recebimentos',
            descricao: 'Acessar mapa de previsão de recebimentos',
            setor: "3" /* Financeiro */,
        },
        'Resumo de Cobrança Diária': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.ResumoCobrancaDiaria },
            acao: 'Acessou o resumo de cobrança diária',
            descricao: 'Acessar resumo de cobrança diária',
            setor: "3" /* Financeiro */,
        },
        'Resumo de Cobrança Mensal': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.ResumoCobrancaMensal },
            acao: 'Acessou o resumo de cobrança mensal',
            descricao: 'Acessar resumo de cobrança mensal',
            setor: "3" /* Financeiro */,
        },
        'Resumo Recebimento Mensal': {
            chaves: { group: permissoes_2.GrupoPermissoes.Mensalidades, role: permissoes_2.FuncaoMensalidades.ResumoRecebimentoMensal },
            acao: 'Acessou o resumo de recebimento mensal',
            descricao: 'Acessar resumo de recebimento mensal',
            setor: "3" /* Financeiro */,
        },
    },
    'Notas de Alunos': {
        'Digitar Notas de Alunos': {
            chaves: { group: permissoes_2.GrupoPermissoes.NotasAlunos, role: permissoes_2.FuncaoNotasAlunos.DigitarNota },
            acao: 'Digitou nota',
            descricao: 'Digitar notas de alunos',
            setor: "2" /* Acadêmico */,
        },
        'Incluir Matérias no Boletim': {
            chaves: { group: permissoes_2.GrupoPermissoes.NotasAlunos, role: permissoes_2.FuncaoNotasAlunos.IncluirMateriasExtras },
            acao: 'Incluíu matéria extra no boletim',
            descricao: 'Incluir matérias extras no boletim',
            setor: "2" /* Acadêmico */,
        },
        'Excluir Matérias do Boletim': {
            chaves: { group: permissoes_2.GrupoPermissoes.NotasAlunos, role: permissoes_2.FuncaoNotasAlunos.ExcluirMateriasExtras },
            acao: 'Excluiu matéria extra do boletim',
            descricao: 'Excluir matérias extras do boletim',
            setor: "2" /* Acadêmico */,
        },
        Relatórios: {
            chaves: { group: permissoes_2.GrupoPermissoes.NotasAlunos, role: permissoes_2.FuncaoNotasAlunos.Relatorios },
            acao: 'Acessou o relatório de notas de alunos',
            descricao: 'Acessar relatório de notas de alunos',
            setor: "2" /* Acadêmico */,
        },
    },
    'Ex-Alunos': Object.assign({ Menu: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.ExAlunos },
            acao: 'Acessou o menu de ex-alunos',
            descricao: 'Acessar dados de ex-alunos',
            setor: "2" /* Acadêmico */,
        } }, (0, permissoes_1.funcoesPadrao)(permissoes_2.GrupoPermissoes.ExAlunos, 'de Ex Alunos', "2" /* Acadêmico */, permissoes_2.GrupoPermissoes.ExAlunos)),
    Caixa: {
        Lançamento: {
            chaves: { group: permissoes_2.GrupoPermissoes.Caixa, role: permissoes_2.FuncaoCaixa.Lancamento },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Caixa, role: permissoes_2.FuncaoCaixa.Lancamento },
            acao: 'Emitiu um lançamento',
            descricao: 'Emitir lançamentos',
            setor: "3" /* Financeiro */,
        },
        Alterar: {
            chaves: { group: permissoes_2.GrupoPermissoes.Caixa, role: permissoes_2.FuncaoCaixa.Alterar },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Caixa, role: permissoes_2.FuncaoCaixa.Alterar },
            acao: 'Alterou um lançamento',
            descricao: 'Alterar lançamentos',
            setor: "3" /* Financeiro */,
        },
        Estornar: {
            chaves: { group: permissoes_2.GrupoPermissoes.Caixa, role: permissoes_2.FuncaoCaixa.Estornar },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Caixa, role: permissoes_2.FuncaoCaixa.Estornar },
            acao: 'Estornou um lançamento',
            descricao: 'Estornar lançamentos',
            setor: "3" /* Financeiro */,
        },
        Relatórios: {
            chaves: { group: permissoes_2.GrupoPermissoes.Caixa, role: permissoes_2.FuncaoCaixa.Relatorios },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Caixa, role: permissoes_2.FuncaoCaixa.Relatorios },
            acao: 'Acessou o relatário de caixa',
            descricao: 'Acessar relatário de caixa',
            setor: "3" /* Financeiro */,
        },
    },
    Configuracoes: {
        'Identificação da Escola': {
            chaves: { group: permissoes_2.GrupoPermissoes.Configuracoes, role: permissoes_2.FuncaoConfiguracoes.IdentificacaoEscola },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Configuracoes, role: permissoes_2.FuncaoConfiguracoes.IdentificacaoEscola },
            acao: 'Alterou a identificação da escola',
            descricao: 'Alterar identificação da escola',
            setor: "1" /* Configurações */,
        },
        'Sistema de Avaliação': {
            chaves: { group: permissoes_2.GrupoPermissoes.Configuracoes, role: permissoes_2.FuncaoConfiguracoes.SistemaAvaliacao },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Configuracoes, role: permissoes_2.FuncaoConfiguracoes.SistemaAvaliacao },
            acao: 'Alterou o sistema de avaliação',
            descricao: 'Alterar o sistema de avaliação',
            setor: "1" /* Configurações */,
        },
        'Dados Para Cobranca': {
            chaves: { group: permissoes_2.GrupoPermissoes.Configuracoes, role: permissoes_2.FuncaoConfiguracoes.DadosParaCobranca },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Configuracoes, role: permissoes_2.FuncaoConfiguracoes.DadosParaCobranca },
            acao: 'Alterou os dados para cobrança',
            descricao: 'Alterar os dados para cobrança',
            setor: "1" /* Configurações */,
        },
        'Configurações Gerais': {
            chaves: { group: permissoes_2.GrupoPermissoes.Configuracoes, role: permissoes_2.FuncaoConfiguracoes.ConfiguracoesGerais },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Configuracoes, role: permissoes_2.FuncaoConfiguracoes.ConfiguracoesGerais },
            acao: 'Alterou as configurações gerais',
            descricao: 'Alterar as configurações gerais',
            setor: "1" /* Configurações */,
        },
        Logotipos: {
            chaves: { group: permissoes_2.GrupoPermissoes.Configuracoes, role: permissoes_2.FuncaoConfiguracoes.Logotipos },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Configuracoes, role: permissoes_2.FuncaoConfiguracoes.Logotipos },
            acao: 'Alterou os logotipos',
            descricao: 'Alterar os logotipos',
            setor: "1" /* Configurações */,
        },
        'Dados de Diretora e Secretária': {
            chaves: { group: permissoes_2.GrupoPermissoes.Configuracoes, role: permissoes_2.FuncaoConfiguracoes.DadosDiretoraSecretaria },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Configuracoes, role: permissoes_2.FuncaoConfiguracoes.DadosDiretoraSecretaria },
            acao: 'Alterou os dados de diretora e secretária',
            descricao: 'Alterar os dados de diretora e secretária',
            setor: "1" /* Configurações */,
        },
        'Configuracões Bancarias': {
            chaves: { group: permissoes_2.GrupoPermissoes.Configuracoes, role: permissoes_2.FuncaoConfiguracoes.ConfiguracoesBancarias },
            chavesLog: { group: permissoes_2.GrupoPermissoes.Configuracoes, role: permissoes_2.FuncaoConfiguracoes.ConfiguracoesBancarias },
            acao: 'Alterou as configuraççães bancárias',
            descricao: 'Alterar as configuraçães bancárias',
            setor: "1" /* Configurações */,
        },
        'Leis dos Documentos': {
            chaves: { group: permissoes_2.GrupoPermissoes.Configuracoes, role: permissoes_2.FuncaoConfiguracoes.LeisDocumentos },
            acao: 'Alterou as leis dos documentos',
            descricao: 'Alterar as leis dos documentos',
            setor: "1" /* Configurações */,
        },
        'Mudar Bimestre Ativo e Recuperação Finalizada': {
            chaves: { group: permissoes_2.GrupoPermissoes.Configuracoes, role: permissoes_2.FuncaoConfiguracoes.MudarBimestreAtivoRecupFinalizada },
            acao: 'Alterou o bimestre ativo e recuperação finalizada',
            descricao: 'Alterar o bimestre ativo e recuperação finalizada',
            setor: "1" /* Configurações */,
        },
        'Configurações do Boletim': {
            chaves: { group: permissoes_2.GrupoPermissoes.Configuracoes, role: permissoes_2.FuncaoConfiguracoes.ConfiguracoesBoletim },
            acao: 'Alterou as configurações do boletim',
            descricao: 'Alterar as configurações do boletim',
            setor: "1" /* Configurações */,
        },
    },
    Cheques: {
        Incluir: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cheques, role: permissoes_2.FuncaoCheques.Incluir },
            chavesLog: { group: 22, role: permissoes_2.FuncaoCheques.Incluir },
            acao: 'Incluiu um cheque',
            descricao: 'Incluir cheques',
            setor: "3" /* Financeiro */,
        },
        Alterar: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cheques, role: permissoes_2.FuncaoCheques.Alterar },
            chavesLog: { group: 22, role: permissoes_2.FuncaoCheques.Alterar },
            acao: 'Alterou um cheque',
            descricao: 'Alterar cheques',
            setor: "3" /* Financeiro */,
        },
        Depoistar: {
            chavesLog: { group: 22, role: 3 },
            acao: 'Depositou cheque',
            descricao: 'Depositar cheques',
            setor: "3" /* Financeiro */,
        },
        Excluir: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cheques, role: permissoes_2.FuncaoCheques.Excluir },
            chavesLog: { group: 22, role: 5 },
            acao: 'Excluiu um cheque',
            descricao: 'Excluir cheques',
            setor: "3" /* Financeiro */,
        },
        Devolução: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cheques, role: permissoes_2.FuncaoCheques.Devolucao },
            chavesLog: { group: 22, role: 4 },
            acao: 'Devolveu cheque',
            descricao: 'Devolver cheques',
            setor: "3" /* Financeiro */,
        },
        Visualizar: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cheques, role: permissoes_2.FuncaoCheques.Visualizar },
            acao: 'Visualizou um cheque',
            descricao: 'Visualizar cheques',
            setor: "3" /* Financeiro */,
        },
        Baixar: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cheques, role: permissoes_2.FuncaoCheques.Baixar },
            acao: 'Baixou um cheque',
            descricao: 'Baixar cheques',
            setor: "3" /* Financeiro */,
        },
        Imprimir: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cheques, role: permissoes_2.FuncaoCheques.Imprimir },
            acao: 'Imprimiu um cheque',
            descricao: 'Imprimir cheques',
            setor: "3" /* Financeiro */,
        },
    },
    ContasPagar: {
        Incluir: {
            chaves: { group: permissoes_2.GrupoPermissoes.ContasPagar, role: permissoes_2.FuncaoContasPagar.Incluir },
            chavesLog: { group: 21, role: permissoes_2.FuncaoContasPagar.Incluir },
            acao: 'Incluiu uma conta a pagar',
            descricao: 'Incluir contas a pagar',
            setor: "3" /* Financeiro */,
        },
        Alterar: {
            chaves: { group: permissoes_2.GrupoPermissoes.ContasPagar, role: permissoes_2.FuncaoContasPagar.Alterar },
            chavesLog: { group: 21, role: 2 },
            acao: 'Alterou uma conta a pagar',
            descricao: 'Alterar contas a pagar',
            setor: "3" /* Financeiro */,
        },
        Excluir: {
            chaves: { group: permissoes_2.GrupoPermissoes.ContasPagar, role: permissoes_2.FuncaoContasPagar.Excluir },
            chavesLog: { group: 21, role: 5 },
            acao: 'Excluiu uma conta a pagar',
            descricao: 'Excluir contas a pagar',
            setor: "3" /* Financeiro */,
        },
        Baixar: {
            chaves: { group: permissoes_2.GrupoPermissoes.ContasPagar, role: permissoes_2.FuncaoContasPagar.Baixar },
            chavesLog: { group: 21, role: 3 },
            acao: 'Baixou uma conta a pagar',
            descricao: 'Baixar contas a pagar',
            setor: "3" /* Financeiro */,
        },
        Estornar: {
            chaves: { group: permissoes_2.GrupoPermissoes.ContasPagar, role: permissoes_2.FuncaoContasPagar.Estornar },
            chavesLog: { group: 21, role: 4 },
            acao: 'Estornou uma conta a pagar',
            descricao: 'Estornar contas a pagar',
            setor: "3" /* Financeiro */,
        },
        Relatórios: {
            chaves: { group: permissoes_2.GrupoPermissoes.ContasPagar, role: permissoes_2.FuncaoContasPagar.Relatorios },
            acao: 'Gerou um relatório de contas a pagar',
            descricao: 'Gerar relatérios de contas a pagar',
            setor: "3" /* Financeiro */,
        },
    },
    Clientes: {
        Menu: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.Clientes },
            acao: 'Acessou os dados de clientes',
            descricao: 'Acessar os dados de clientes',
            setor: "2" /* Acadêmico */,
        },
        Incluir: {
            chaves: { group: permissoes_2.GrupoPermissoes.Clientes, role: permissoes_2.FuncaoClientes.Incluir },
            acao: 'Incluiu um cliente',
            descricao: 'Incluir clientes',
            setor: "2" /* Acadêmico */,
        },
        Alterar: {
            chaves: { group: permissoes_2.GrupoPermissoes.Clientes, role: permissoes_2.FuncaoClientes.Alterar },
            acao: 'Alterou um cliente',
            descricao: 'Alterar clientes',
            setor: "2" /* Acadêmico */,
        },
        Excluir: {
            chaves: { group: permissoes_2.GrupoPermissoes.Clientes, role: permissoes_2.FuncaoClientes.Excluir },
            acao: 'Excluiu um cliente',
            descricao: 'Excluir clientes',
            setor: "2" /* Acadêmico */,
        },
        Dependentes: {
            chaves: { group: permissoes_2.GrupoPermissoes.Clientes, role: permissoes_2.FuncaoClientes.InclurExcluirFilhos },
            acao: 'Alterou dependentes do cliente',
            descricao: 'Alterar dependentes do cliente',
            setor: "2" /* Acadêmico */,
        },
        Relatórios: {
            chaves: { group: permissoes_2.GrupoPermissoes.Clientes, role: permissoes_2.FuncaoClientes.Relatorios },
            acao: 'Gerou relatério de clientes',
            descricao: 'Gerar relatérios de clientes',
            setor: "2" /* Acadêmico */,
        },
    },
    //OpcoesMenu: { role: 22, funcoes: {} } },
    Arquivo: {
        'Criar Base de Dados': {
            chaves: { group: permissoes_2.GrupoPermissoes.Arquivo, role: permissoes_2.FuncaoArquivo.CriarBaseDados },
            chavesLog: { group: 1, role: permissoes_2.FuncaoArquivo.CriarBaseDados },
            acao: 'Criou base de dados',
            descricao: 'Criar base de dados',
            setor: "1" /* Configurações */,
        },
        'Reconstruir Base Dados': {
            chaves: { group: permissoes_2.GrupoPermissoes.Arquivo, role: permissoes_2.FuncaoArquivo.ReconstruirBaseDados },
            chavesLog: { group: 1, role: permissoes_2.FuncaoArquivo.ReconstruirBaseDados },
            acao: 'Reconstruiu base de dados',
            descricao: 'Reconstruir base de dados',
            setor: "1" /* Configurações */,
        },
        'Reindexar Bases Dados': {
            chaves: { group: permissoes_2.GrupoPermissoes.Arquivo, role: permissoes_2.FuncaoArquivo.ReindexarBasesDados },
            chavesLog: { group: 1, role: permissoes_2.FuncaoArquivo.ReindexarBasesDados },
            acao: 'Reindexou bases de dados',
            descricao: 'Reindexar bases de dados',
            setor: "1" /* Configurações */,
        },
        'Refazer Balanço Abertura': {
            chaves: { group: permissoes_2.GrupoPermissoes.Arquivo, role: permissoes_2.FuncaoArquivo.RefazerBalancoAbertura },
            chavesLog: { group: 1, role: 23 },
            acao: 'Refez balanço abertura',
            descricao: 'Refazer balanço abertura',
            setor: "1" /* Configurações */,
        },
        'Recalcular Saldos do Plano de Contas': {
            chaves: { group: permissoes_2.GrupoPermissoes.Arquivo, role: permissoes_2.FuncaoArquivo.RecalcularSaldosPlanoContas },
            acao: 'Recalculou saldos do plano de contas',
            descricao: 'Recalcular saldos do plano de contas',
            setor: "1" /* Configurações */,
        },
        'Atualizar Plano e Histórico de Outros Anos': {
            chaves: { group: permissoes_2.GrupoPermissoes.Arquivo, role: permissoes_2.FuncaoArquivo.AtualizarPlanoHistoricoOutrosAnos },
            acao: 'Atualizou plano e histórico contábil de outros anos',
            descricao: 'Atualizar plano e histórico contábil de outros anos',
            setor: "3" /* Financeiro */,
        },
        'Selecionar Arquivos': {
            chaves: { group: permissoes_2.GrupoPermissoes.Arquivo, role: permissoes_2.FuncaoArquivo.SelecionarArquivos },
            acao: 'Selecionou arquivos',
            descricao: 'Selecionar arquivos',
            setor: "1" /* Configurações */,
        },
        'Cópia de Segurança': {
            chaves: { group: permissoes_2.GrupoPermissoes.Arquivo, role: permissoes_2.FuncaoArquivo.CopiaSeguranca },
            chavesLog: { group: 1, role: 4 },
            acao: 'Criou uma cópia de segurança',
            descricao: 'Criar cópia de segurança',
            setor: "1" /* Configurações */,
        },
        'Restaurar Cópia de Segurança': {
            chaves: { group: permissoes_2.GrupoPermissoes.Arquivo, role: permissoes_2.FuncaoArquivo.RestaurarCopiaSeguranca },
            chavesLog: { group: 1, role: 5 },
            acao: 'Restaurou uma cópia de segurança',
            descricao: 'Restaurar cópia de segurança',
            setor: "1" /* Configurações */,
        },
        'Recalcular Notas': {
            chaves: { group: permissoes_2.GrupoPermissoes.Arquivo, role: permissoes_2.FuncaoArquivo.RecalcularNotas },
            acao: 'Recalculou notas',
            descricao: 'Recalcular notas',
            setor: "1" /* Configurações */,
        },
        'Reprocessar Contabilidade': {
            chaves: { group: permissoes_2.GrupoPermissoes.Arquivo, role: permissoes_2.FuncaoArquivo.ReprocessarContabilidade },
            chavesLog: { group: 1, role: 6 },
            acao: 'Reprocessou contabilidade',
            descricao: 'Reprocessar contabilidade',
            setor: "3" /* Financeiro */,
        },
        'Importação e Exportação de Dados': {
            chaves: { group: permissoes_2.GrupoPermissoes.Arquivo, role: permissoes_2.FuncaoArquivo.ImportacaoExportacaoDados },
            acao: 'Acessou importação e exportação de dados',
            descricao: 'Acessar importação e exportação de dados',
            setor: "1" /* Configurações */,
        },
        'Diretório de Trabalho': {
            chaves: { group: permissoes_2.GrupoPermissoes.Arquivo, role: permissoes_2.FuncaoArquivo.DiretorioTrabalho },
            chavesLog: { group: 1, role: 8 },
            acao: 'Alterou o diretério de trabalho',
            descricao: 'Alterar o diretério de trabalho',
            setor: "1" /* Configurações */,
        },
        'Ano Ativo': {
            chaves: { group: permissoes_2.GrupoPermissoes.Arquivo, role: permissoes_2.FuncaoArquivo.AnoAtivo },
            chavesLog: { group: 1, role: 9 },
            acao: 'Alterou o ano ativo',
            descricao: 'Alterar o ano ativo',
            setor: "1" /* Configurações */,
        },
        'Configurar Impressora': {
            chaves: { group: permissoes_2.GrupoPermissoes.Arquivo, role: permissoes_2.FuncaoArquivo.ConfigurarImpressora },
            chavesLog: { group: 1, role: 10 },
            acao: 'Configurou a impressora',
            descricao: 'Configurar impressora',
            setor: "1" /* Configurações */,
        },
        'Configuracoes da Escola': {
            chaves: { group: permissoes_2.GrupoPermissoes.Arquivo, role: permissoes_2.FuncaoArquivo.ConfiguracoesEscola },
            chavesLog: { group: 1, role: 11 },
            acao: 'Alterou as configurações da escola',
            descricao: 'Alterar as configurações da escola',
            setor: "1" /* Configurações */,
        },
    },
    'Cadastros Financeiros': {
        'Grupo de Produtos': {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.GrupoProdutos },
            acao: 'Alterou grupo de produto',
            descricao: 'Alterar grupo de produto',
            setor: "3" /* Financeiro */,
        },
        Produtos: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.Produtos },
            acao: 'Alterou produto',
            descricao: 'Alterar produto',
            setor: "3" /* Financeiro */,
        },
        'Planos e Formas de Pagamento': {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.PlanosPagamento },
            acao: 'Alterou plano e forma de pagamento',
            descricao: 'Alterar plano e forma de pagamento',
            setor: "3" /* Financeiro */,
        },
        'Tipos de Desconto': {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.TiposDesconto },
            acao: 'Alterou tipo de desconto',
            descricao: 'Alterar tipo de desconto',
            setor: "3" /* Financeiro */,
        },
        'Categoria de Aluno': {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.CategoriasAlunos },
            acao: 'Alterou categoria de aluno',
            descricao: 'Alterar categoria de aluno',
            setor: "3" /* Financeiro */,
        },
        Cobradora: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.Cobradoras },
            acao: 'Alterou cobradora',
            descricao: 'Alterar cobradora',
            setor: "3" /* Financeiro */,
        },
    },
    'Cadastros Acadêmico': {
        Horários: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.Horarios },
            acao: 'Alterou horário',
            descricao: 'Alterar horários',
            setor: "2" /* Acadêmico */,
        },
        'Grade de Aulas': {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.GradeAulas },
            acao: 'Alterou grade de aulas',
            descricao: 'Alterar grade de aulas',
            setor: "2" /* Acadêmico */,
        },
        'Conteúdo Ministrado': {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.ConteudoMinistrado },
            acao: 'Alterou conteúdo ministrado',
            descricao: 'Alterar conteúdo ministrado',
            setor: "2" /* Acadêmico */,
        },
        'Conteúdo Ministrado Relatórios': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.ConteudoMinistrado },
            acao: 'Gerou relatório de conteúdo ministrado',
            descricao: 'Gerar relatório de conteúdo ministrado',
            setor: "2" /* Acadêmico */,
        },
        'Grade Currícular': {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.GradeCurricular },
            acao: 'Alterou grade currícular',
            descricao: 'Alterar grade currícular',
            setor: "2" /* Acadêmico */,
        },
        'Agenda e Evento': {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.AgendaEventos },
            acao: 'Alterou agenda de evento',
            descricao: 'Alterar agenda de eventos',
            setor: "2" /* Acadêmico */,
        },
        'Empréstimo de Livro': {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.EmprestimoLivros },
            acao: 'Alterou empréstimo de livro',
            descricao: 'Alterar empréstimos de livros',
            setor: "2" /* Acadêmico */,
        },
        Bairro: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.Bairros },
            acao: 'Alterou bairro',
            descricao: 'Alterar bairros',
            setor: "2" /* Acadêmico */,
        },
        Legenda: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.Legendas },
            acao: 'Alterou legenda',
            descricao: 'Alterar legendas',
            setor: "2" /* Acadêmico */,
        },
        Visitante: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.Visitantes },
            acao: 'Alterou visitante',
            descricao: 'Alterar visitantes',
            setor: "2" /* Acadêmico */,
        },
        Atitude: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.Atitudes },
            acao: 'Alterou atitude',
            descricao: 'Alterar atitudes',
            setor: "2" /* Acadêmico */,
        },
        Reconhecimento: {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.Reconhecimentos },
            acao: 'Alterou reconhecimento de curso',
            descricao: 'Alterar reconhecimento de curso',
            setor: "2" /* Acadêmico */,
        },
        'Período de Bimestres': {
            chaves: { group: permissoes_2.GrupoPermissoes.Cadastro, role: permissoes_2.FuncaoCadastro.PeriodoBimestres },
            acao: 'Alterou período de bimestre',
            descricao: 'Alterar período de bimestres',
            setor: "2" /* Acadêmico */,
        },
    },
    Secretaria: {
        Relatórios: {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.Relatorios },
            acao: 'Gerou relatório de secretaria',
            descricao: 'Gerar relatórios de secretaria',
            setor: "2" /* Acadêmico */,
        },
        Frequência: {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.Frequencia },
            acao: 'Acessou dados de frequência',
            descricao: 'Acessar dados de frequência',
            setor: "2" /* Acadêmico */,
        },
        'Registro de Frequência Manual': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.RegistroFrequenciaManual },
            acao: 'Registrou frequência manual',
            descricao: 'Registrar frequência manual',
            setor: "2" /* Acadêmico */,
        },
        'Registro de Frequência por Cartão': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.RegistroFrequenciaCartao },
            acao: 'Registrou frequência por cartão',
            descricao: 'Registrar frequência por cartão',
            setor: "2" /* Acadêmico */,
        },
        'Calcular Faltas do Boletim': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.CalcularFaltasBoletins },
            acao: 'Calculou faltas do boletim',
            descricao: 'Calcular faltas do boletim',
            setor: "2" /* Acadêmico */,
        },
        'Ler Arquivo Catraca': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.LerArquivoCatraca },
            acao: 'Leu arquivo da catraca',
            descricao: 'Ler arquivo da catraca',
            setor: "2" /* Acadêmico */,
        },
        'Relatório de Frequência de Alunos': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.RelatorioFrequenciaAlunos },
            acao: 'Gerou relatório de frequência de alunos',
            descricao: 'Gerar relatório de frequência de alunos',
            setor: "2" /* Acadêmico */,
        },
        'Relatórios da Catraca': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.RelatoriosCatraca },
            acao: 'Gerou relatório da catraca',
            descricao: 'Gerar relatório da catraca',
            setor: "2" /* Acadêmico */,
        },
        'Calcular Aulas Dadas e Previstas Apartir da Presença Manual': {
            chaves: {
                group: permissoes_2.GrupoPermissoes.Secretaria,
                role: permissoes_2.FuncaoSecretaria.CalcularAulasDadasPrevistasApartirPresencaManual,
            },
            acao: 'Calculou aulas dadas e previstas pelas presenças',
            descricao: 'Calcular aulas dadas e previstas pelas presenças',
            setor: "1" /* Configurações */,
        },
        Notas: {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.Notas },
            acao: 'Acessou relatório de notas',
            descricao: 'Acessar relatório de notas',
            setor: "2" /* Acadêmico */,
        },
        'Relatórios Boletins Conferência': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.ImprimirBoletinsConferencia },
            acao: 'Gerou relatório de boletins',
            descricao: 'Gerar relatórios de boletins',
            setor: "2" /* Acadêmico */,
        },
        'Relatório Avaliações Módulo Online': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.RelatorioAvaliacoesModuloOnline },
            acao: 'Gerou relatório de avaliações',
            descricao: 'Gerar relatório de avaliações',
            setor: "2" /* Acadêmico */,
        },
        'Relatórios de Médias': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.RelatoriosMedias },
            acao: 'Gerou relatório de médias',
            descricao: 'Gerar relatório de médias',
            setor: "2" /* Acadêmico */,
        },
        'Digitação de Notas': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.DigitacaoNotas },
            acao: 'Digitou nota',
            descricao: 'Digitar notas',
            setor: "2" /* Acadêmico */,
        },
        'Digitação Boletins de Aluno': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.DigitacaoBoletinsAluno },
            acao: 'Digitou no boletim',
            descricao: 'Digitar no boletim',
            setor: "2" /* Acadêmico */,
        },
        'Digitação Nova de Notas': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.DigitacaoNovaNotas },
            acao: 'Digitou na nova tela de nota',
            descricao: 'Digitar na nova tela de notas',
            setor: "2" /* Acadêmico */,
        },
        'Recálculo Boletins pelas Avaliacoes': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.RecalculoBoletinsPartirAvaliacoes },
            acao: 'Recalculou as nota',
            descricao: 'Recalcular as notas',
            setor: "2" /* Acadêmico */,
        },
        'Digitação Avaliações Descritivas': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.DigitacaoAvaliacoesDescritivas },
            acao: 'Digitou avaliação descritiva',
            descricao: 'Digitar avaliações descritivas',
            setor: "2" /* Acadêmico */,
        },
        Recuperação: {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.Recuperacao },
            acao: 'Acessou dados de alunos em recuperação',
            descricao: 'Acessar dados de alunos em recuperação',
            setor: "2" /* Acadêmico */,
        },
        Reprovados: {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.Reprovados },
            acao: 'Acessou dados de alunos reprovados',
            descricao: 'Acessar dados de alunos reprovados',
            setor: "2" /* Acadêmico */,
        },
        Aprovados: {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.Aprovados },
            acao: 'Acessou dados de alunos aprovados',
            descricao: 'Acessar dados de alunos aprovados',
            setor: "2" /* Acadêmico */,
        },
        'Relatório Individual': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.RelatorioIndividual },
            acao: 'Acessou relatório individual',
            descricao: 'Acessar relatório individual',
            setor: "2" /* Acadêmico */,
        },
        'Relatório de Avaliação Continua': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.RelAvaliacaoContinua },
            acao: 'Acessou relatório de avaliação continua',
            descricao: 'Acessar relatório de avaliação continua',
            setor: "2" /* Acadêmico */,
        },
        'Encerramento do Ano Letivo': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.EncerramentoAnoLetivo },
            acao: 'Encerrou o ano letivo',
            descricao: 'Encerrar o ano letivo',
            setor: "1" /* Configurações */,
        },
        'Cálculo de Média Final': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.CalculoMediaFinal },
            acao: 'Recalculou a média final',
            descricao: 'Recalcular a média final',
            setor: "2" /* Acadêmico */,
        },
        'Abertura do Ano Letivo': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.AberturaAnoLetivo },
            acao: 'Executou a abertura do ano letivo',
            descricao: 'Executar a abertura do ano letivo',
            setor: "1" /* Configurações */,
        },
        'ReMatrícula Automática': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.ReMatriculaAutomatica },
            acao: 'Executou a rematrícula automática',
            descricao: 'Executar a rematrícula automática',
            setor: "1" /* Configurações */,
        },
        Utilitários: {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.Utilitarios },
            acao: 'Acessou menu de utilitários',
            descricao: 'Acessar menu de utilitários',
            setor: "2" /* Acadêmico */,
        },
        'Retornar Alunos por Situação no Curso': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.RetornarAlunosSituacaoCurso },
            acao: 'Retornou alunos por situação no curso',
            descricao: 'Retornar alunos por situação no curso',
            setor: "2" /* Acadêmico */,
        },
        'Acrescentar ou Remover Vírgulas nas Notas do Historico': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.AcrescentarRemoverVirgulasNotasHistorico },
            acao: 'Alterou vírgulas nas notas do historico',
            descricao: 'Alterar vírgulas nas notas do historico',
            setor: "2" /* Acadêmico */,
        },
        'Marcar Documentos Como Não Entregues': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.MarcarDocumentosComoNaoEntregues },
            acao: 'Alterou entrega de documentos',
            descricao: 'Marcar documentos como não entregues',
            setor: "2" /* Acadêmico */,
        },
        'Fechar Reabrir Ano Letivo': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.FecharReabrirAnoLetivo },
            acao: 'Alterou status do ano letivo',
            descricao: 'Alterar status do ano letivo',
            setor: "1" /* Configurações */,
        },
        'Geração de Senhas para Pais e Alunos': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.GeracaoSenhasPaisAlunos },
            acao: 'Gerou senhas para pais e alunos',
            descricao: 'Gerar senhas para pais e aluno',
            setor: "1" /* Configurações */,
        },
        'Ficha Individual': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.FichaIndividual },
            acao: 'Acessou relatórios de Ficha Individual',
            descricao: 'Acessar relatórios de Ficha Individual',
            setor: "2" /* Acadêmico */,
        },
        'Histórico Escolar': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.HistoricoEscolar },
            acao: 'Acessou relatórios de Histórico Escolar',
            descricao: 'Acessar relatórios de Histórico Escolar',
            setor: "2" /* Acadêmico */,
        },
        'Relatório Final': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.RelatorioFinal },
            acao: 'Acessou relatórios de Relatório Final',
            descricao: 'Acessar relatórios de Relatório Final',
            setor: "2" /* Acadêmico */,
        },
        'Relatório Final MARFIN': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.RelatorioFinalMARFIN },
            acao: 'Acessou relatórios de Relatório Final MARFIN',
            descricao: 'Acessar relatórios de Relatório Final MARFIN',
            setor: "2" /* Acadêmico */,
        },
        'Exportação EducaCenso': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.ExportacaoEducaCenso },
            acao: 'Acessou Exportação EducaCenso',
            descricao: 'Acessar Exportação EducaCenso',
            setor: "2" /* Acadêmico */,
        },
        'Ficha Familiar': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.FichaFamiliar },
            acao: 'Acessou relatórios de Ficha Familiar',
            descricao: 'Acessar relatórios de Ficha Familiar',
            setor: "2" /* Acadêmico */,
        },
        'Gerenciador de Turmas': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.GerenciadorTurmas },
            acao: 'Acessou Gerenciador de Turmas ',
            descricao: 'Acessar Gerenciador de Turmas ',
            setor: "2" /* Acadêmico */,
        },
        'Aulas Dadas Turma': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.AulasDadasTurma },
            acao: 'Acessou Aulas Dadas',
            descricao: 'Acessar Aulas Dadas',
            setor: "2" /* Acadêmico */,
        },
        'Observações SOE': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.ObservacoesSOE },
            acao: 'Alterou Observações SOE',
            descricao: 'Acessar daddos de Observações SOE',
            setor: "2" /* Acadêmico */,
        },
        'Relatório de Atestados Médicos': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.RelatorioAtestadosMedicos },
            acao: 'Acessou relatórios de Atestados Médicos',
            descricao: 'Acessar relatórios de Atestados Médicos',
            setor: "2" /* Acadêmico */,
        },
        'Diário de Classe': {
            chaves: { group: permissoes_2.GrupoPermissoes.Secretaria, role: permissoes_2.FuncaoSecretaria.DiarioClasse },
            acao: 'Acessou relatórios de Diário de Classe',
            descricao: 'Acessar relatórios de Diário de Classe',
            setor: "2" /* Acadêmico */,
        },
    },
    Tesouraria: {
        'Movimento de Caixa': {
            chaves: { group: permissoes_2.GrupoPermissoes.Tesouraria, role: permissoes_2.FuncaoTesouraria.MovimentoCaixa },
            acao: 'Alterou Movimento de Caixa',
            descricao: 'Acessar daddos de Movimento de Caixa',
            setor: "3" /* Financeiro */,
        },
        Cheques: {
            chaves: { group: permissoes_2.GrupoPermissoes.Tesouraria, role: permissoes_2.FuncaoTesouraria.Cheques },
            acao: 'Alterou dados de Cheques',
            descricao: 'Acessar daddos de Cheques',
            setor: "3" /* Financeiro */,
        },
        Cobrança: {
            chaves: { group: permissoes_2.GrupoPermissoes.Tesouraria, role: permissoes_2.FuncaoTesouraria.Cobranca },
            acao: 'Alterou daddos de Cobrança',
            descricao: 'Acessar daddos de Cobrança',
            setor: "3" /* Financeiro */,
        },
        'Imprimir Carnê Cobranca': {
            chaves: { group: permissoes_2.GrupoPermissoes.Tesouraria, role: permissoes_2.FuncaoTesouraria.ImprimirCarneCobranca },
            chavesLog: { group: 13, role: 19 },
            acao: 'Gerou Carnê Cobranca',
            descricao: 'Gerar Carnê Cobranca',
            setor: "3" /* Financeiro */,
        },
        'Enviar Cobrança Banco': {
            chaves: { group: permissoes_2.GrupoPermissoes.Tesouraria, role: permissoes_2.FuncaoTesouraria.EnviarCobrancaBanco },
            chavesLog: { group: 13, role: 24 },
            acao: 'Gerou arquivo de Cobrança Banco',
            descricao: 'Gerar arquivo de Cobrança Banco',
            setor: "3" /* Financeiro */,
        },
        'Banco Confirmou título': {
            chavesLog: { group: 13, role: 21 },
            acao: 'Banco confirmou o título',
            descricao: 'Confirmar título no banco',
            setor: "3" /* Financeiro */,
        },
        'Banco Rejeitou  título': {
            chavesLog: { group: 13, role: 22 },
            acao: 'Banco rejeitou o título',
            descricao: 'Título rejeitado no banco',
            setor: "3" /* Financeiro */,
        },
        'Quebra de Agrupamento Bloqueto': {
            chavesLog: { group: 13, role: 25 },
            acao: 'Quebrou de Agrupamento de parcelas',
            descricao: 'Quebrar de Agrupamento de parcelas',
            setor: "3" /* Financeiro */,
        },
        'Baixa Aut. Exp. Juno': {
            chavesLog: { group: 13, role: 26 },
            acao: 'Baixou aut.título de Juno',
            descricao: 'Baixar automáticamente título em Juno',
            setor: "3" /* Financeiro */,
        },
        'Sinc. Ret_pag Juno': {
            chavesLog: { group: 13, role: 27 },
            acao: 'Sinc. Ret_pag Juno',
            descricao: 'Sinc. Ret_pag Juno',
            setor: "3" /* Financeiro */,
        },
        'Alerta, Baixa Aut. Juno': {
            chavesLog: { group: 13, role: 28 },
            acao: 'Alerta, Baixa Aut. Juno',
            descricao: 'Alerta, Baixa Aut. Juno',
            setor: "3" /* Financeiro */,
        },
        'Reg. de Parc. Sinc. Ret_Pag Juno': {
            chavesLog: { group: 13, role: 29 },
            acao: 'Reg. de Parc. Sinc. Ret_Pag Juno',
            descricao: 'Reg. de Parc. Sinc. Ret_Pag Juno',
            setor: "3" /* Financeiro */,
        },
        'Confirmou Matrícula por Juno': {
            chavesLog: { group: 13, role: 30 },
            acao: 'Confirmou Matrícula por Juno',
            descricao: 'Confirmou Matrícula por Juno',
            setor: "3" /* Financeiro */,
        },
        'Baixa Aut. Exp. PJBank': {
            chavesLog: { group: 13, role: 31 },
            acao: 'Baixou aut.título de PJBank',
            descricao: 'Baixar automáticamente título em PJBank',
            setor: "3" /* Financeiro */,
        },
        'Sinc. Ret_pag PJBank': {
            chavesLog: { group: 13, role: 32 },
            acao: 'Sinc. Ret_pag PJBank',
            descricao: 'Sinc. Ret_pag PJBank',
            setor: "3" /* Financeiro */,
        },
        'Alerta, Baixa Aut. PJBank': {
            chavesLog: { group: 13, role: 33 },
            acao: 'Alerta, Baixa Aut. PJBank',
            descricao: 'Alerta, Baixa Aut. PJBank',
            setor: "3" /* Financeiro */,
        },
        'Reg. de Parc. Sinc. Ret_Pag PJBank': {
            chavesLog: { group: 13, role: 34 },
            acao: 'Reg. de Parc. Sinc. Ret_Pag PJBank',
            descricao: 'Reg. de Parc. Sinc. Ret_Pag PJBank',
            setor: "3" /* Financeiro */,
        },
        'Confirmou Matrícula por PJBank': {
            chavesLog: { group: 13, role: 35 },
            acao: 'Confirmou Matrícula por PJBank',
            descricao: 'Confirmou Matrícula por PJBank',
            setor: "3" /* Financeiro */,
        },
        'Baixa Aut. Exp. Iugu': {
            chavesLog: { group: 13, role: 36 },
            acao: 'Baixou aut.título de Iugu',
            descricao: 'Baixar automáticamente título em Iugu',
            setor: "3" /* Financeiro */,
        },
        'Sinc. Ret_pag Iugu': {
            chavesLog: { group: 13, role: 37 },
            acao: 'Sinc. Ret_pag Iugu',
            descricao: 'Sinc. Ret_pag Iugu',
            setor: "3" /* Financeiro */,
        },
        'Alerta, Baixa Aut. Iugu': {
            chavesLog: { group: 13, role: 38 },
            acao: 'Alerta, Baixa Aut. Iugu',
            descricao: 'Alerta, Baixa Aut. Iugu',
            setor: "3" /* Financeiro */,
        },
        'Reg. de Parc. Sinc. Ret_Pag Iugu': {
            chavesLog: { group: 13, role: 39 },
            acao: 'Reg. de Parc. Sinc. Ret_Pag Iugu',
            descricao: 'Reg. de Parc. Sinc. Ret_Pag Iugu',
            setor: "3" /* Financeiro */,
        },
        'Confirmou Matrícula por Iugu': {
            chavesLog: { group: 13, role: 40 },
            acao: 'Confirmou Matrícula por Iugu',
            descricao: 'Confirmou Matrícula por Iugu',
            setor: "3" /* Financeiro */,
        },
        'Gerar Arquivo para Débito em Conta': {
            chaves: { group: permissoes_2.GrupoPermissoes.Tesouraria, role: permissoes_2.FuncaoTesouraria.GerarArquivoDebitoConta },
            acao: 'Gerou Arquivo para Débito em Conta',
            descricao: 'Gerar Arquivo para Débito em Conta',
            setor: "3" /* Financeiro */,
        },
        'Gerar Arquivo Cobradora': {
            chaves: { group: permissoes_2.GrupoPermissoes.Tesouraria, role: permissoes_2.FuncaoTesouraria.GerarArquivoCobradora },
            acao: 'Gerou Arquivo Cobradora',
            descricao: 'Gerar Arquivo Cobradora',
            setor: "3" /* Financeiro */,
        },
        'Gerar Arquivo para Pagamento de Funcionários': {
            chaves: { group: permissoes_2.GrupoPermissoes.Tesouraria, role: permissoes_2.FuncaoTesouraria.GerarArquivoPagamentoFuncionarios },
            acao: 'Gerou Arquivo para Pagamento de Funcionários',
            descricao: 'Gerar Arquivo para Pagamento de Funcionários',
            setor: "3" /* Financeiro */,
        },
        'Imprimir Carnês Somente Valor': {
            chaves: { group: permissoes_2.GrupoPermissoes.Tesouraria, role: permissoes_2.FuncaoTesouraria.ImprimirCarnesSomenteValor },
            acao: 'Gerou Carnês Somente Valor',
            descricao: 'Gerar Carnês Somente Valor',
            setor: "3" /* Financeiro */,
        },
        'Listagem Alunos com Débito em Conta': {
            chaves: { group: permissoes_2.GrupoPermissoes.Tesouraria, role: permissoes_2.FuncaoTesouraria.ListagemAlunosDebitoConta },
            acao: 'Acessou relatórios de Alunos com Débito em Conta',
            descricao: 'Acessar relatórios de Alunos com Débito em Conta',
            setor: "3" /* Financeiro */,
        },
        'Alterar Dia Vencimento Mensalidades': {
            chaves: { group: permissoes_2.GrupoPermissoes.Tesouraria, role: permissoes_2.FuncaoTesouraria.AlterarDiaVencimentoMensalidades },
            acao: '',
            descricao: '',
            setor: "3" /* Financeiro */,
        },
        'Gerar Parcelas Adicionais Cobrança': {
            chaves: { group: permissoes_2.GrupoPermissoes.Tesouraria, role: permissoes_2.FuncaoTesouraria.GerarParcelasAdicionaisCobranca },
            acao: 'Gerou Parcelas Adicionais Cobrança',
            descricao: 'Gerar Parcelas Adicionais Cobrança',
            setor: "3" /* Financeiro */,
        },
        'Histórico de Impressões de Bloquetos': {
            chaves: { group: permissoes_2.GrupoPermissoes.Tesouraria, role: permissoes_2.FuncaoTesouraria.HistoricoImpressoesBloquetos },
            acao: 'Acessou Histórico de Impressões de Bloquetos',
            descricao: 'Acessar Histórico de Impressões de Bloquetos',
            setor: "3" /* Financeiro */,
        },
        'Baixa de Mensalidades': {
            chaves: { group: permissoes_2.GrupoPermissoes.Tesouraria, role: permissoes_2.FuncaoTesouraria.BaixaMensalidades },
            acao: 'Acessou Baixa de Mensalidades',
            descricao: 'Acessar Baixa de Mensalidades',
            setor: "3" /* Financeiro */,
        },
        Manual: {
            chaves: { group: permissoes_2.GrupoPermissoes.Tesouraria, role: permissoes_2.FuncaoTesouraria.Manual },
            acao: 'Acessou Baixa Manual',
            descricao: 'Acessar Baixa Manual',
            setor: "3" /* Financeiro */,
        },
        Automática: {
            chaves: { group: permissoes_2.GrupoPermissoes.Tesouraria, role: permissoes_2.FuncaoTesouraria.Automatica },
            chavesLog: { group: 13, role: 20 },
            acao: 'Acessou Baixa Automática',
            descricao: 'Acessar Baixa Automática',
            setor: "3" /* Financeiro */,
        },
        'Autenticação Mecânica': {
            chaves: { group: permissoes_2.GrupoPermissoes.Tesouraria, role: permissoes_2.FuncaoTesouraria.AutenticacaoMecanica },
            acao: 'Acessou Autenticação Mecânica',
            descricao: 'Acessar Autenticação Mecânica',
            setor: "3" /* Financeiro */,
        },
        //TODO: WTF
        'Por Categoria': {
            chaves: { group: permissoes_2.GrupoPermissoes.Tesouraria, role: permissoes_2.FuncaoTesouraria.PorCategoria },
            acao: '',
            descricao: '',
            setor: "3" /* Financeiro */,
        },
        'Configuração de Descontos': {
            chaves: { group: permissoes_2.GrupoPermissoes.Tesouraria, role: permissoes_2.FuncaoTesouraria.ConfiguracaoDescontos },
            acao: 'Alterou Configuração de Descontos',
            descricao: 'Acessar daddos de Configuração de Descontos',
            setor: "3" /* Financeiro */,
        },
        'Relatórios de Contas à Pagar': {
            chaves: { group: permissoes_2.GrupoPermissoes.Tesouraria, role: permissoes_2.FuncaoTesouraria.RelatoriosContasPagar },
            acao: 'Acessou relatórios de Contas à Pagar',
            descricao: 'Acessar relatórios de Contas à Pagar',
            setor: "3" /* Financeiro */,
        },
        'Relatórios de Mensalidades': {
            chaves: { group: permissoes_2.GrupoPermissoes.Tesouraria, role: permissoes_2.FuncaoTesouraria.RelatoriosMensalidades },
            acao: 'Acessou relatórios de Mensalidades',
            descricao: 'Acessar relatórios de Mensalidades',
            setor: "3" /* Financeiro */,
        },
        'Relatório Gratuídades': {
            chaves: { group: permissoes_2.GrupoPermissoes.Tesouraria, role: permissoes_2.FuncaoTesouraria.RelatorioGratuidades },
            acao: 'Acessou relatórios de Gratuídades',
            descricao: 'Acessar relatórios de Gratuídades',
            setor: "3" /* Financeiro */,
        },
        'Relatórios de Contabilidade': {
            chaves: { group: permissoes_2.GrupoPermissoes.Tesouraria, role: permissoes_2.FuncaoTesouraria.RelatoriosContabilidade },
            acao: 'Acessou relatórios de Contabilidade',
            descricao: 'Acessar relatórios de Contabilidade',
            setor: "3" /* Financeiro */,
        },
        'Relatórios de Cheques': {
            chaves: { group: permissoes_2.GrupoPermissoes.Tesouraria, role: permissoes_2.FuncaoTesouraria.RelatoriosCheques },
            acao: 'Acessou relatórios de Cheques',
            descricao: 'Acessar relatórios de Cheques',
            setor: "3" /* Financeiro */,
        },
        'Relatório de Transporte': {
            chaves: { group: permissoes_2.GrupoPermissoes.Tesouraria, role: permissoes_2.FuncaoTesouraria.RelatorioTransporte },
            acao: 'Acessou relatórios de Transporte',
            descricao: 'Acessar relatórios de Transporte',
            setor: "1" /* Configurações */,
        },
    },
    Administração: {
        'Caixa da Administração': {
            chaves: { group: permissoes_2.GrupoPermissoes.Administracao, role: permissoes_2.FuncaoAdministracao.CaixaAdministracao },
            acao: 'Alterou Caixa da Administração',
            descricao: 'Acessar daddos do Caixa da Administração',
            setor: "4" /* Administrativo */,
        },
        'Fluxo de Caixa': {
            chaves: { group: permissoes_2.GrupoPermissoes.Administracao, role: permissoes_2.FuncaoAdministracao.FluxoCaixa },
            acao: 'Alterou Fluxo de Caixa',
            descricao: 'Acessar daddos de Fluxo de Caixa',
            setor: "4" /* Administrativo */,
        },
        'Movimento Bancário': {
            chaves: { group: permissoes_2.GrupoPermissoes.Administracao, role: permissoes_2.FuncaoAdministracao.MovimentoBancario },
            acao: 'Alterou Movimento Bancário',
            descricao: 'Acessar daddos de Movimento Bancário',
            setor: "4" /* Administrativo */,
        },
        'Aplicações Financeiras': {
            chaves: { group: permissoes_2.GrupoPermissoes.Administracao, role: permissoes_2.FuncaoAdministracao.AplicacoesFinanceiras },
            acao: 'Acessou dados de Aplicações Financeiras',
            descricao: 'Acessar daddos de Aplicações Financeiras',
            setor: "4" /* Administrativo */,
        },
        'Fechar ou Reabrir a Contabilidade Mes': {
            chaves: { group: permissoes_2.GrupoPermissoes.Administracao, role: permissoes_2.FuncaoAdministracao.FecharReabrirContabilidadeMes },
            acao: 'Alterou o status da Contabilidade do mês',
            descricao: 'Acessar daddos da Contabilidade do mês ',
            setor: "4" /* Administrativo */,
        },
        'Fechar a Contabilidade Mes': {
            chavesLog: { group: 23, role: 23 },
            acao: 'Fechou contabilidade do mês',
            descricao: 'Fechar Contabilidade do mês ',
            setor: "4" /* Administrativo */,
        },
        'Reabrir a Contabilidade Mes': {
            chavesLog: { group: 23, role: 24 },
            acao: 'Reabriu contabilidade do mês',
            descricao: 'Reabrir contabilidade do mês ',
            setor: "4" /* Administrativo */,
        },
        'Relatoórios Administrativos': {
            chaves: { group: permissoes_2.GrupoPermissoes.Administracao, role: permissoes_2.FuncaoAdministracao.RelatoriosAdministrativos },
            acao: 'Acessou relatórios Administrativos',
            descricao: 'Acessar relatórios Administrativos',
            setor: "4" /* Administrativo */,
        },
        'Cadastro de Centro de Custo': {
            chaves: { group: permissoes_2.GrupoPermissoes.Administracao, role: permissoes_2.FuncaoAdministracao.CadastroCentroCusto },
            acao: 'Alterou Centro de Custo',
            descricao: 'Acessar dados de Centro de Custo',
            setor: "4" /* Administrativo */,
        },
    },
    Estatística: {
        'Gráficos Estatísticos': {
            chaves: { group: permissoes_2.GrupoPermissoes.Estatastica, role: permissoes_2.FuncaoEstatastica.GraficosEstatisticos },
            acao: 'Acessou relatórios de Gráficos Estatísticos',
            descricao: 'Acessar relatórios de Gráficos Estatísticos',
            setor: "4" /* Administrativo */,
        },
        'Número de Alunos por Bairro': {
            chaves: { group: permissoes_2.GrupoPermissoes.Estatastica, role: permissoes_2.FuncaoEstatastica.NAlunosBairro },
            acao: 'Acessou relatórios de Alunos por Bairro',
            descricao: 'Acessar relatórios de Alunos por Bairro',
            setor: "4" /* Administrativo */,
        },
        'Número de Alunos por Turma': {
            chaves: { group: permissoes_2.GrupoPermissoes.Estatastica, role: permissoes_2.FuncaoEstatastica.NAlunosTurma },
            acao: 'Acessou relatórios de Alunos por Turma',
            descricao: 'Acessar relatórios de Alunos por Turma',
            setor: "4" /* Administrativo */,
        },
        Ranking: {
            chaves: { group: permissoes_2.GrupoPermissoes.Estatastica, role: permissoes_2.FuncaoEstatastica.Ranking },
            acao: 'Acessou relatórios de Ranking',
            descricao: 'Acessar relatórios de Ranking',
            setor: "4" /* Administrativo */,
        },
        'Estatística por Religião': {
            chaves: { group: permissoes_2.GrupoPermissoes.Estatastica, role: permissoes_2.FuncaoEstatastica.EstatasticaReligiao },
            acao: 'Acessou relatórios de Estatística por Religião',
            descricao: 'Acessar relatórios de Estatística por Religião',
            setor: "4" /* Administrativo */,
        },
        'Estatística por Categoria': {
            chaves: { group: permissoes_2.GrupoPermissoes.Estatastica, role: permissoes_2.FuncaoEstatastica.EstatasticaCategoria },
            acao: 'Acessou relatórios de Estatística por Categoria',
            descricao: 'Acessar relatórios de Estatística por Categoria',
            setor: "4" /* Administrativo */,
        },
        'Estatística por Situacao': {
            chaves: { group: permissoes_2.GrupoPermissoes.Estatastica, role: permissoes_2.FuncaoEstatastica.EstatasticaSituacao },
            acao: 'Acessou relatórios de Estatística por Situacao',
            descricao: 'Acessar relatórios de Estatística por Situacao',
            setor: "4" /* Administrativo */,
        },
        'Estatística por Raca e Cor': {
            chaves: { group: permissoes_2.GrupoPermissoes.Estatastica, role: permissoes_2.FuncaoEstatastica.EstatasticaRacaCor },
            acao: 'Acessou relatórios de Estatística por Raca e Cor',
            descricao: 'Acessar relatórios de Estatística por Raca e Cor',
            setor: "4" /* Administrativo */,
        },
    },
    Utilitarios: {
        'Enviar Mensagem': {
            chaves: { group: permissoes_2.GrupoPermissoes.Utilitarios, role: permissoes_2.FuncaoUtilitarios.EnviarMensagemRede },
            chavesLog: { group: 1, role: 15 },
            acao: 'Enviou Mensagem',
            descricao: 'Enviar Mensagem',
            setor: "1" /* Configurações */,
        },
        'DeltaUpdate Atualizar Via Internet': {
            chaves: { group: permissoes_2.GrupoPermissoes.Utilitarios, role: permissoes_2.FuncaoUtilitarios.DeltaUpdateAtualizarViaInternet },
            acao: 'Acessou DeltaUpdate Atualizar Via Internet',
            descricao: 'Acessar DeltaUpdate para Atualizar Via Internet',
            setor: "1" /* Configurações */,
        },
        'Checar Integridade do Sistema': {
            chaves: { group: permissoes_2.GrupoPermissoes.Utilitarios, role: permissoes_2.FuncaoUtilitarios.ChecarIntegridadeSistema },
            acao: 'Checou Integridade do Sistema',
            descricao: 'Checar Integridade do Sistema',
            setor: "1" /* Configurações */,
        },
    },
    Internet: {
        'Rematrícula Online': {
            chaves: { group: permissoes_2.GrupoPermissoes.Internet, role: permissoes_2.FuncaoInternet.RematriculaOnline },
            acao: 'Alterou dados da Rematrícula Online',
            descricao: 'Acessar dados da Rematrícula Online',
            setor: "2" /* Acadêmico */,
        },
        'Exportador Internet': {
            chaves: { group: permissoes_2.GrupoPermissoes.Internet, role: permissoes_2.FuncaoInternet.ExportadorInternet },
            acao: 'Acessou Exportador Internet',
            descricao: 'Acessar Exportador Internet',
            setor: "1" /* Configurações */,
        },
        'Monitor Sincronização': {
            chaves: { group: permissoes_2.GrupoPermissoes.Internet, role: permissoes_2.FuncaoInternet.MonitorSincronizacao },
            acao: 'Alterou dados do Monitor Sincronização',
            descricao: 'Acessar dados do Monitor Sincronização',
            setor: "1" /* Configurações */,
        },
        'Gerenciador Módulos Web': {
            chaves: { group: permissoes_2.GrupoPermissoes.Internet, role: permissoes_2.FuncaoInternet.GerenciadorModulosWeb },
            acao: 'Alterou dados do Gerenciador Módulos Web',
            descricao: 'Acessar dados do Gerenciador Módulos Web',
            setor: "1" /* Configurações */,
        },
    },
    //Janelas: { role: 31, funcoes: {} } },
    //Ajuda: { role: 32, funcoes: {} } },
};
exports.Permissao = (0, permissoes_1.filtrarPermissoes)(exports.schema);
exports.Log = (0, permissoes_1.filtrarLogs)(exports.schema);
